import offerFilters from "@/apollo/queries/offer/offerFilters";

export default async function ({ route, error, app, store }) {
  const category = route.params.category;
  if (category !== 'cars' && category !== 'new') return;

  const siteId = store.getters.site_id;

  try {
    const { data } = await app.apolloProvider.defaultClient.query({
      query: offerFilters,
      variables: {
        url: route.path,
        site_id: siteId,
        limit: 1,
        page: 1
      },
      fetchPolicy: 'no-cache'
    });
    const totalOffers = data.offers?.total || 0;

    if (totalOffers === 0) {
      console.warn(`Middleware: 0 cars found for ${route.path}`);
      return error({ statusCode: 404 });
    }

  } catch (e) {
    console.error('Middleware Validation Error:', e.message);
    return error({ statusCode: 404 });
  }
}
